import React, { useEffect, useLayoutEffect, useState } from "react";
// mui component
import { Box, Stack, Button, Input } from "@mui/material";

/** Custom Hooks **/
import { useNavbar } from "../../context/NavBarContext";

/** icon **/
import { IoChevronBack } from "react-icons/io5";
import { GrSearch } from "react-icons/gr";

/** Fetch RTK QUERY API **/
import { searchApi, useFetchSearchDataQuery } from "../../api/searchApi";

/*** REUSABLE COMPONENTS ***/
import InputGroup from "../../components/reusable/inputGroup/InputGroup";
import ParallelCard from "../../components/homepage/parallelCard/ParallelCard";

/*** CUSTOM HOOk ***/
import { useInput } from "../../hooks";

const Search = () => {
  const [skip, setSkip] = useState(true);
  const [inPageLoading, setInPageLoading] = useState(false);

  const Navbar = useNavbar();
  const searchInput = useInput("");

  const { data, isFetching, error } = useFetchSearchDataQuery(
    searchInput.value,
    {
      skip,
    }
  );

  useLayoutEffect(() => {
    Navbar.setLogoPlace("Search");
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);
  }, []);

  useEffect(() => {
    let timeoutId;
    if (searchInput.value.length > 0) {
      // setInPageLoading(true);
      timeoutId = setTimeout(() => {
        setSkip(false);
        // setInPageLoading(false);
      }, 800);
    }
    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchInput.value]);

  // i used useEffect to set Skip state true
  // after fetching data
  useEffect(() => {
    if (data) {
      setSkip(true);
    }
  }, [data]);

  if (error) {
    setSkip(true);
    // return <div>Error</div>;
  }

  return (
    <>
      <Stack spacing={1.5}>
        <InputGroup
          icon={<GrSearch className="text-amber-300" fontSize="20" />}
          inputClassName={`rounded-full`}
          placeholder="Search..."
          {...searchInput}
        />
      </Stack>
      {isFetching || inPageLoading && <h1>Loading</h1>}
      {error && <h1>error</h1>}

      {data && !isFetching && data.music.length > 0 && <ParallelCard data={data.music} title={"Song"} category_type={"songs"} />}
      {data && !isFetching && data.album.length > 0 && <ParallelCard data={data.album} title={"Album"} category_type={"album"} />}
      {data && !isFetching && data.artist.length > 0 && <ParallelCard data={data.artist} title={"Artist"} category_type={"artist"} />}
    
    </>
  );
};

export default Search;
